const Images = {
  logo: require("./new-logo.svg").default,
  logoWithName: require("./new-logo-w-name.svg").default,
  fileImage: require("./fileLogo.svg").default,
};
module.exports = Images;
